module.exports = __webpack_public_path__ + "img/file.becad5fc.svg";